<template>
  <thux-table
    :instance="instance"
    :instance-name="instanceName"
    :order-by-dict="orderByDict"
    :goBack="goBack"
    :list="list"
    :fieldName="fieldName"
    :fields="fields"
    :fields-column="fieldsColumn"
    :select-all="selectAll"
    :selected-list="selectedList"
    :get-local-selected-all="getLocalSelectedAll"
    :local-selected-list="localSelectedList"
    @check-all="checkAll('id')"
    @check-none="checkNone('id')"
    @set-selected-row="setSelectedRow($event, 'id')"
    :show-checks="showChecks"
    :showDetailButton="showDetailButton"
    @change-status="changeInstanceStatus"
    @sort-changed="orderTable"
    @remove-order-by="removeOrderFromTable"
    @open-detail-form="$emit('open-detail-form', $event)"
  />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as TASK_TAG_TYPES } from './store'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxTableMixin from '../../../components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin'

export default {
  name: 'TaskTagTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      fields: [
        {
          key: 'checks',
          label: this.$t('Checks')
        },
        {
          key: 'status',
          label: this.$t('Status'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'status'
        },
        {
          key: 'name',
          label: this.$t('Name'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'name'
        },
        {
          key: 'action',
          label: this.$t('Actions'),
          tdClass: 'text-right text-nowrap',
          thClass: 'text-right text-nowrap'
        }
      ],
      fieldsColumn: ['status', 'name'],
      fieldName: 'id'
    }
  },
  computed: {
    ...mapGetters({
      selectAll: TASK_TAG_TYPES.GENERIC.task['task-tag'].LIST.GETTERS.selectAll,
      selectedList: TASK_TAG_TYPES.GENERIC.task['task-tag'].LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showDetailButton () {
      return hasPerm('tasks_tasktag_retrieve')
    }
  },
  methods: {
    ...mapMutations({
      setList: TASK_TAG_TYPES.GENERIC.task['task-tag'].LIST.MUTATIONS.setList,
      setSelectedList:
        TASK_TAG_TYPES.GENERIC.task['task-tag'].LIST.MUTATIONS.setSelectedList,
      setSelectAll: TASK_TAG_TYPES.GENERIC.task['task-tag'].LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...TASK_TAG_TYPES.GENERIC.task['task-tag'].LIST.ACTIONS
    })
  }
}
</script>
